import React, { useState } from "react";
import { ThemeProvider } from "@emotion/react";
import theme from "../../theme/theme";
import Navbar from "../nav/Navbar";
import Footer from "../footer/Footer";
import Drawer from "../sideBar/SideBar";
import { Box } from "@mui/system";
import showNav from "../../context/scrollContext";
import useMediaQuery from "@mui/material/useMediaQuery";

function Layout({ children }) {
  const mobMatch = useMediaQuery("(max-width:600px)");

  const [openDrawer, setOpenDrawer] = useState(false);
  const handleDrawerOpen = () => {
    setOpenDrawer(true);
  };

  const handleDrawerClose = () => {
    setOpenDrawer(false);
  };

  const [show, setShow] = React.useState(false);

  const onScroll = (e) => {
    const currentScrollY = e.target.scrollTop;
    if (currentScrollY >= 400) setShow(true);
    else setShow(false);
  };

  return (
    <div
      style={mobMatch ? {} : { overflowY: "scroll", height: "100%" }}
      onScroll={onScroll}
    >
      <showNav.Provider value={show}>
        <ThemeProvider theme={theme}>
          <Box sx={{ backgroundColor: { xs: "#EBEBEB", sm: "white" } }}>
            <Navbar
              handleOpenDrawer={handleDrawerOpen}
              openDrawer={openDrawer}
            ></Navbar>
            <Drawer openDrawer={openDrawer} handleClose={handleDrawerClose} />
            <main>{children}</main>
            <Footer />
          </Box>
        </ThemeProvider>
      </showNav.Provider>
    </div>
  );
}

export default Layout;
